exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "body .newbets-container,body .newbets-container .main-header .logo{font-family:Saira Condensed,sans-serif}body .newbets-container .carrinho_row .info{color:#5d3dad}body .newbets-container .h1,body .newbets-container .h2,body .newbets-container .h3,body .newbets-container .h4,body .newbets-container .h5,body .newbets-container .h6,body .newbets-container .main-header .sidebar-toggle,body .newbets-container h1,body .newbets-container h2,body .newbets-container h3,body .newbets-container h4,body .newbets-container h5,body .newbets-container h6{font-family:Saira Condensed,sans-serif}body .newbets-container .btn.btn-success{background-color:#20a10b;border-color:#34b51f}body .newbets-container .btn.btn-primary{background-color:#5d3dad;border-color:#673ab7}body .newbets-container .btn.btn-cartela.btn-selected{background-color:#5d3dad;border-color:#673ab7;color:#fff!important}body .newbets-container .btn.btn-danger{background-color:#e70431;border-color:#f10e38}body .newbets-container .btn{background-color:#e0e0e0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/common/themes/newbets.scss
// module id = 989
// module chunks = 0